export type DevlakeProject = { name: string; hasCicd: boolean };

export const PROJECT_PARAM = 'project';

const remembered = new Map<string, string[]>();

export const normalize = (names: string[]): string[] =>
  [...new Set(names.filter(name => name.length > 0))].sort();

export const readProjects = (params: URLSearchParams): string[] =>
  normalize(params.getAll(PROJECT_PARAM));

export const writeProjects = (
  params: URLSearchParams,
  names: string[],
): URLSearchParams => {
  const next = new URLSearchParams(params);
  next.delete(PROJECT_PARAM);
  normalize(names).forEach(name => next.append(PROJECT_PARAM, name));
  return next;
};

export const rememberProjects = (entityRef: string, names: string[]) => {
  remembered.set(entityRef, normalize(names));
};

// Undefined when nothing is remembered; an empty list means All projects was chosen.
export const recallProjects = (entityRef: string): string[] | undefined => {
  const names = remembered.get(entityRef);
  return names && [...names];
};

export const forgetRememberedProjects = () => {
  remembered.clear();
};

export const sameProjects = (a: string[], b: string[]): boolean => {
  const left = normalize(a);
  const right = normalize(b);
  return (
    left.length === right.length &&
    left.every((name, index) => name === right[index])
  );
};
